import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const BulkDeviceIcon = (properties: iconType) => {
  const { stroke } = properties;
  return (
    <SvgIcon
      {...properties}
      viewBox="0 0 23 28"
      style={{ fill: 'none', width: '24px', height: '32px', strokeWidth: '.07rem' }}
    >
      <path
        fill={stroke}
        stroke="none"
        d="M9.63708 23.8894L6.98745 23.8894L6.98745 18.6968L9.63708 18.6968L9.63708 23.8894Z"
      />
      <path fill={stroke} stroke="none" d="M8.31204 15L5 19.4447L11.6241 19.4447L8.31204 15Z" />
      <path d="M1 28H16V13.1905L11.0368 7H1V28Z" strokeLinejoin="round" />
      <path d="M17.1176 25H18V12V10.1905L13.0368 4H3V6" strokeLinejoin="round" />
      <path d="M19.1176 22H20V9V7.19048L15.0368 1H5V3" strokeLinejoin="round" />
      <path d="M11 7V13H16" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export default BulkDeviceIcon;
